module.exports = __webpack_public_path__ + "img/cgr_sonic_20s_mars_2022.5a5aaf57.jpg";